import { render, staticRenderFns } from "./Tramitar.vue?vue&type=template&id=69ae592c&scoped=true"
import script from "./Tramitar.vue?vue&type=script&lang=js"
export * from "./Tramitar.vue?vue&type=script&lang=js"
import style0 from "./Tramitar.vue?vue&type=style&index=0&id=69ae592c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ae592c",
  null
  
)

export default component.exports